import type { Usage } from '../types';

/**
 * Credits this user can spend right now, as the server counts them: the monthly
 * allowance left PLUS the bonus bucket (`usage.credits.available`, computed by
 * the server's CreditService::getRemaining). `undefined` when no credit usage
 * is loaded. Every credit gate reads this: recomputing from used/limit leaves
 * the bonus out and refuses spends the server accepts (backlog c-114). Falls
 * back to the allowance for a server that sends no `available`.
 *
 * Its own module, not the store's: page tests mock the store module wholesale,
 * and a gate must not lose its rule with the mock.
 */
export function spendableCredits(usage: Usage | null | undefined): number | undefined {
  const credits = usage?.credits;
  if (!credits) return undefined;
  return credits.available ?? credits.remaining;
}
